import React from 'react';
import { TemplateSwitch } from 'src/templates';

const BlogPostPage = (props) => {
  return <TemplateSwitch {...props} />;
};

export default BlogPostPage;
